import React from "react";
import styled from "styled-components";

import CardSectionBackgroundImg from "../../images/background10.jpg"

import { Marginer } from "../../Components/marginer"

import Button from "@material-ui/core/Button"
import { CardC } from "../../Components/cardc"

const CardSectionContainer = styled.div`
	width: 100%;
	height: 700px;
	background: url(${CardSectionBackgroundImg});
	background-position: 0px -150px;
	background-size: column;
`;

const BackgroundFilter = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(38, 70, 83, 0.9);
	display: flex;
	flex-direction: cover;

`;


const CardSectionInnerContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
`;

export function CardSection(props){
	return <CardSectionContainer>
	<BackgroundFilter>
	<CardSectionInnerContainer>
	<CardC />
	</CardSectionInnerContainer>
	</BackgroundFilter>
	</CardSectionContainer>
} 